/*============================================================================
  added-to-cart.js — Fetch 1.2.1

  Ao adicionar um produto, o tema abre o cart drawer inteiro. O documento de
  CRO (pág. 4) pede o contrário: uma confirmação curta com duas saídas —
  fechar a compra ou continuar comprando.

  Como o drawer é suprimido sem tocar em theme.js
  -----------------------------------------------
  theme.HeaderCart escuta 'ajaxProduct:added' e chama open(), que devolve
  cedo quando theme.settings.cartType !== 'dropdown'. Este arquivo registra
  seu listener ANTES do tema (roda durante o parse; theme.js inicializa as
  seções depois), troca cartType por um sentinela e restaura no tick
  seguinte, quando todos os listeners do dispatch já rodaram.

  O drawer não é desativado: continua abrindo pelo ícone do carrinho, pelo
  evento 'cart:open' e no /cart. Só deixa de aparecer sozinho.

  Vanilla. Sem jQuery. Sem dependência de theme.js — se ele não existir, o
  painel abre do mesmo jeito.
==============================================================================*/

(function () {
  'use strict';

  var SENTINELA = 'sn-suppressed';
  // AUTO-FECHAMENTO DESLIGADO.
  //
  // O painel sumia sozinho em 7s. Quem parasse para ler, decidir ou tirar um
  // print voltava e clicava no vazio — o "Check out nao funciona" mais provavel
  // nao era o botao, era o painel ja ter fechado embaixo do cursor.
  //
  // Confirmacao com CTA primario nao deve ter prazo. Ela fecha por Escape,
  // clique fora, X ou "Continue shopping" — quatro saidas, todas do visitante.
  var AUTO_MS = 0;
  var CHAVE_TRILHA = 'sn:last-browse';

  // Páginas que valem como "estava navegando aqui". Produto não entra: voltar
  // para a PDP que o visitante acabou de deixar não é continuar comprando.
  var TIPOS_NAVEGACAO = ['index', 'collection', 'list-collections', 'search', 'blog', 'article', 'page'];

  var painel = null;
  var timerAuto = null;
  var focoAnterior = null;

  function guardar(area, chave, valor) {
    try {
      if (arguments.length === 2) return window[area].getItem(chave);
      window[area].setItem(chave, valor);
      return valor;
    } catch (e) {
      return null;
    }
  }

  /*------------------------------------------------------------------------
    PORTAL DE OVERLAY — REMOVIDO, e a lição fica registrada.

    Havia aqui um portal que movia o cart drawer e o menu para o BODY, para
    escapar do contexto de empilhamento da .transition-body e ficar acima da
    barra fixa do app (z 2147480000).

    Dois problemas:

    1. Todo o CSS do drawer esta escopado em
       `[data-section-type="header"] .site-header__drawers-container > #HeaderCart`.
       Mover o no destruiu essa cadeia e o painel perdeu altura cheia,
       ancoragem e recorte — virou um cartao flutuante no meio da tela.

    2. A barra do app NAO EXISTE MAIS. Ela foi ocultada por CSS varias rodadas
       atras e some do DOM. Medido: `.__seguno-banner-container` -> ausente.
       A guerra de empilhamento inteira era contra um elemento que ja nao
       renderizava.

    Sem a barra, a escala normal basta: --z-drawer para o painel e um degrau
    abaixo para o veu, ambos no lugar original. Nao reintroduzir portal sem
    antes reescrever os seletores para nao dependerem do ancestral.
  ------------------------------------------------------------------------*/

  /*------------------------------------------------------------------------
    Supressão do drawer — precisa estar registrada antes do tema
  ------------------------------------------------------------------------*/

  document.addEventListener('ajaxProduct:added', function () {
    if (!window.theme || !theme.settings) return;
    var original = theme.settings.cartType;
    if (original === SENTINELA) return;
    theme.settings.cartType = SENTINELA;
    // Todos os listeners deste dispatch são síncronos; o timeout devolve o
    // valor real assim que a fila esvazia.
    window.setTimeout(function () {
      theme.settings.cartType = original;
    }, 0);
  });

  /*------------------------------------------------------------------------
    Painel
  ------------------------------------------------------------------------*/

  function achar() {
    if (!painel || !document.body.contains(painel)) {
      painel = document.querySelector('[data-added-to-cart]');
    }
    return painel;
  }

  function dinheiro(cents) {
    if (window.theme && theme.Currency && theme.Currency.formatMoney) {
      return theme.Currency.formatMoney(cents, theme.moneyFormat);
    }
    return (cents / 100).toFixed(2);
  }

  function preencher(item) {
    var p = achar();
    if (!p) return;

    var img = p.querySelector('[data-added-image]');
    if (img) {
      var src = item.image || item.featured_image || '';
      if (src && src.url) src = src.url;
      if (src) {
        // 160px cobre o dobro do slot de 64px em telas retina.
        img.src = src.indexOf('?') > -1 ? src : src + '?width=160';
        img.alt = item.product_title || item.title || '';
        img.hidden = false;
      } else {
        img.hidden = true;
      }
    }

    var titulo = p.querySelector('[data-added-title]');
    if (titulo) titulo.textContent = item.product_title || item.title || '';

    var variante = p.querySelector('[data-added-variant]');
    if (variante) {
      // "Default Title" é o rótulo interno de produto sem variante.
      var v = item.variant_title;
      if (v && v !== 'Default Title') {
        variante.textContent = v;
        variante.hidden = false;
      } else {
        variante.hidden = true;
      }
    }

    var preco = p.querySelector('[data-added-price]');
    if (preco) {
      var linha = (item.quantity && item.quantity > 1)
        ? item.quantity + ' × ' + dinheiro(item.price)
        : dinheiro(item.price);
      preco.innerHTML = linha;
    }
  }

  function contar() {
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) {
        var p = achar();
        if (!p) return;
        p.querySelectorAll('[data-added-count]').forEach(function (el) {
          el.textContent = c.item_count > 0 ? ' (' + c.item_count + ')' : '';
        });
      })
      .catch(function () {});
  }

  function abrir(item) {
    var p = achar();
    if (!p) return;

    focoAnterior = document.activeElement;
    preencher(item);
    contar();

    p.hidden = false;
    // Marca no <html> para o CTA fixo do mobile sair da frente: dois blocos
    // de ação empilhados no rodapé disputam o mesmo polegar.
    document.documentElement.classList.add('sn-added-open');
    // Um frame para o browser registrar o estado inicial e a transição valer.
    window.requestAnimationFrame(function () {
      p.classList.add('sn-added--open');
      p.setAttribute('aria-hidden', 'false');
    });

    var fechar1 = p.querySelector('[data-added-close]');
    if (fechar1) fechar1.focus();

    document.addEventListener('keydown', naTecla);
    reiniciarAuto();
  }

  function fechar() {
    var p = achar();
    if (!p || p.hidden) return;

    p.classList.remove('sn-added--open');
    p.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('sn-added-open');
    window.clearTimeout(timerAuto);
    document.removeEventListener('keydown', naTecla);

    window.setTimeout(function () {
      p.hidden = true;
    }, 260);

    if (focoAnterior && focoAnterior.focus) focoAnterior.focus();
    focoAnterior = null;
  }

  function naTecla(evt) {
    if (evt.key === 'Escape' || evt.keyCode === 27) fechar();
  }

  function reiniciarAuto() {
    window.clearTimeout(timerAuto);
    if (!AUTO_MS) return;
    var p = achar();
    if (!p) return;
    // Some sozinho, mas não enquanto o visitante estiver com o mouse ou o
    // foco dentro dele.
    timerAuto = window.setTimeout(function () {
      if (p.matches(':hover') || p.contains(document.activeElement)) {
        reiniciarAuto();
        return;
      }
      fechar();
    }, AUTO_MS);
  }

  /*------------------------------------------------------------------------
    Ligações
  ------------------------------------------------------------------------*/

  document.addEventListener('ajaxProduct:added', function (evt) {
    var item = evt.detail && evt.detail.product;

    // O "Quick buy" do card dispara o mesmo evento, mas nem sempre com o
    // objeto do item — daí o painel abrir com $0 e a foto vazia. Quando o
    // detalhe vier incompleto, o carrinho é a fonte de verdade: pega o
    // último item adicionado.
    var completo = item && item.price != null && (item.product_title || item.title);
    if (completo) {
      abrir(item);
      return;
    }

    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) {
        if (!c.items || !c.items.length) return;
        abrir(c.items[c.items.length - 1]);
      })
      .catch(function () {});
  });

  /*------------------------------------------------------------------------
    "Continue shopping" — para onde ele leva

    Regra: de volta à última página de navegação de verdade (coleção, home,
    busca, blog). Se não houver — visitante caiu direto na PDP por anúncio ou
    link — vai para a coleção de todos os produtos.

    Deliberadamente NÃO usa history.back(): quem chegou de fora da loja
    voltaria para fora dela.
  ------------------------------------------------------------------------*/

  function anotarTrilha() {
    var p = achar();
    var tipo = p && p.dataset.pageType;
    if (!tipo || TIPOS_NAVEGACAO.indexOf(tipo) === -1) return;
    guardar('sessionStorage', CHAVE_TRILHA, window.location.pathname + window.location.search);
  }

  function continuarComprando() {
    var p = achar();
    var atual = window.location.pathname + window.location.search;
    var trilha = guardar('sessionStorage', CHAVE_TRILHA);
    var reserva = (p && p.dataset.continueUrl) || '/collections/all';
    var destino = trilha && trilha !== atual ? trilha : reserva;

    fechar();
    // O botão também existe dentro do cart drawer; fecha os dois.
    document.dispatchEvent(new CustomEvent('cart:close'));

    // Já está no destino: navegar seria recarregar a mesma página à toa.
    if (destino === atual) return;

    window.location.assign(destino);
  }

  anotarTrilha();

  document.addEventListener('click', function (evt) {
    if (!evt.target.closest) return;

    // Botão de fechar (o X) só fecha; "Continue shopping" navega.
    if (evt.target.closest('[data-added-keep], [data-cart-keep-shopping]')) {
      evt.preventDefault();
      continuarComprando();
      return;
    }

    if (evt.target.closest('[data-added-close]')) {
      evt.preventDefault();
      fechar();
      return;
    }

    // Fundo escurecido e X do cart drawer. Delegado aqui em vez de amarrado
    // no init do tema: o fundo é irmão do drawer e não estava no seu escopo.
    if (evt.target.closest('[data-cart-close]')) {
      evt.preventDefault();
      document.dispatchEvent(new CustomEvent('cart:close'));
      return;
    }

    // Clique fora do painel fecha.
    var p = achar();
    if (p && !p.hidden && !evt.target.closest('.sn-added__panel')) fechar();
  });

  // Abrir o carrinho de verdade encerra a confirmação: dois painéis do mesmo
  // assunto ao mesmo tempo é ruído.
  document.addEventListener('cart:open', fechar);
  document.addEventListener('drawerOpen', fechar);

  ['mouseenter', 'focusin'].forEach(function (e) {
    document.addEventListener(e, function (evt) {
      if (evt.target.closest && evt.target.closest('.sn-added__panel')) reiniciarAuto();
    }, true);
  });
})();
